import { SelectItem } from "../modelo/selectItem";

export class Estado {
    static values = (): SelectItem[] => {
        var estadoList: SelectItem[] = [];
        estadoList.push(new SelectItem("Selecione o Estado",null));
        estadoList.push(new SelectItem("AC","AC"));
        estadoList.push(new SelectItem("AL","AL"));
        estadoList.push(new SelectItem("AM","AM"));
        estadoList.push(new SelectItem("AP","AP"));
        estadoList.push(new SelectItem("BA","BA"));
        estadoList.push(new SelectItem("CE","CE"));
        estadoList.push(new SelectItem("DF","DF"));
        estadoList.push(new SelectItem("ES","ES"));
        estadoList.push(new SelectItem("GO","GO"));
        estadoList.push(new SelectItem("MA","MA"));
        estadoList.push(new SelectItem("MG","MG"));
        estadoList.push(new SelectItem("MS","MS"));
        estadoList.push(new SelectItem("MT","MT"));
        estadoList.push(new SelectItem("PA","PA"));
        estadoList.push(new SelectItem("PB","PB"));
        estadoList.push(new SelectItem("PE","PE"));
        estadoList.push(new SelectItem("PI","PI"));
        estadoList.push(new SelectItem("PR","PR"));
        estadoList.push(new SelectItem("RJ","RJ"));
        estadoList.push(new SelectItem("RN","RN"));
        estadoList.push(new SelectItem("RO","RO"));
        estadoList.push(new SelectItem("RR","RR"));
        estadoList.push(new SelectItem("RS","RS"));
        estadoList.push(new SelectItem("SC","SC"));
        estadoList.push(new SelectItem("SE","SE"));
        estadoList.push(new SelectItem("SP","SP"));
        estadoList.push(new SelectItem("TO","TO"));
        return estadoList;
    }
}


// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/enumaration/estado.ts